import React from "react";
import HoneyAmla from "../../images/collection/amla-candy.jpg";
import StawberryJam from "../../images/collection/strawberry-jam.jpg";
import OrangeJam from "../../images/collection/orange-jam.jpg";
import HoneySoap from "../../images/collection/soap-honey-comb-arrangement.jpg";
import HoneyShampoo from "../../images/collection/6613153.jpg";
import HoneyDryfruits from "../../images/collection/honey-dryfruit.jpg";
import HoneyCinamon from "../../images/collection/cinamon-honey.jpg";
import NaturalHoney from "../../images/collection/natural-honey.jpg";
import HoneyFaceWash from "../../images/collection/honey-face-wash.jpg";
import { Row, Col } from "react-bootstrap";
import "./CollectionProduct.css";


const CollectionProduct = ({ title }) => {
  const collections = [
    {
      img: NaturalHoney,
      collectionName: "Natural Honey ",
    },
    {
      img: HoneyAmla,
      collectionName: "Honey Amla Candy",
    },
    {
      img: StawberryJam,
      collectionName: "Honey Strawberry Jam",
    },
    {
      img: OrangeJam,
      collectionName: "Honey Orange Jam",
    },
    {
      img: HoneySoap,
      collectionName: "Honey Soap",
    },
    {
      img: HoneyShampoo,
      collectionName: "Honey Shampoo",
    },
    {
      img: HoneyDryfruits,
      collectionName: "Honey Dryfruits",
    },
    {
      img: HoneyCinamon,
      collectionName: "Cinamon Honey ",
    },
    {
      img: HoneyFaceWash,
      collectionName: "Honey Face Wash",
    },
  ];
  return (
    <div className="container product-img subSectionWrapper px-0 pt-4 pb-0">
      {title && (
        <h2 className="text-center title mb-4 mb-lg-5 container-title">
          {title}
        </h2>
      )}
      <Row className="justify-content-center">
        {collections.map((e,i) => (
          <Col md={4} lg={2} sm={6} xs= {6} key={i}>
            <div className="image-container image-container-collections mb-4">
              <img className="" src={e.img} alt="Investment asset" />
            </div>
            <h3 className="text-center image-caption mt-0  mb-4 text-decoration-none">
              {e.collectionName}
            </h3>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default CollectionProduct;
